import React from "react";

const PanicPopup = ({ onClose }) => {
  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center bg-black/70 backdrop-blur-sm">
      <div className="relative w-[90%] max-w-md bg-gray-900 text-white rounded-2xl shadow-[0_0_25px_rgba(255,0,0,0.6)] overflow-hidden border border-red-700 animate-fadeIn">
        
        {/* Red top bar */}
        <div className="h-1 bg-gradient-to-r from-red-600 via-red-400 to-red-600 animate-pulse"></div>

        {/* Main content */}
        <div className="p-8 text-center">
          {/* Alert symbol */}
          <div className="text-red-500 text-6xl font-bold mb-4 animate-pulse">!</div>

          {/* Title */}
          <h2 className="text-2xl font-extrabold uppercase tracking-wide mb-3">
            Suspicious Activity Detected
          </h2>

          {/* Description */}
          <p className="text-gray-300 text-base leading-relaxed mb-6">
            Your actions have triggered a security alert.
            <br />
            This event has been <span className="text-red-400 font-semibold">recorded</span> and reported to the invigilator.
          </p>

          {/* Button */}
          <button
            onClick={onClose}
            className="bg-red-600 hover:bg-red-700 px-6 py-2.5 rounded-lg text-white font-semibold tracking-wide shadow-lg hover:shadow-red-500/40 transition-all duration-200"
          >
            Continue Test
          </button>
        </div>
      </div>

      {/* Custom animations */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
          }
          .animate-fadeIn {
            animation: fadeIn 0.3s ease-out;
          }
        `}
      </style>
    </div>
  );
};

export default PanicPopup;
